import { Breadcrumbs } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SpaceXxs, ColorGray900, SpaceMd, FontSize200 } from "@nxt-costco-com/forge-design-tokens";
const StyledBreadcrumb = styled(Breadcrumbs, {
  shouldForwardProp: () => true
})({
  fontWeight: 400,
  fontSize: FontSize200,
  color: ColorGray900,
  button: {
    backgroundColor: "transparent",
    ":hover": {
      backgroundColor: "transparent"
    },
    svg: {
      paddingTop: "5px",
      height: "21px",
      width: SpaceMd,
      color: ColorGray900
    }
  },
  ".MuiBreadcrumbs-separator": {
    margin: `0 ${SpaceXxs}`
  }
});
const StyledLastLink = styled("a")({
  color: ColorGray900,
  textDecoration: "none",
  ":hover": {
    textDecoration: "underline"
  }
});
export {
  StyledBreadcrumb,
  StyledLastLink
};
